// actions/teamActionTypes.js
export const FETCH_TEAM_DATA_REQUEST = 'FETCH_TEAM_DATA_REQUEST';
export const FETCH_TEAM_DATA_SUCCESS = 'FETCH_TEAM_DATA_SUCCESS';
export const FETCH_TEAM_DATA_FAILURE = 'FETCH_TEAM_DATA_FAILURE';
export const ADD_TEAM_DATA_REQUEST = 'ADD_TEAM_DATA_REQUEST';
export const ADD_TEAM_DATA_SUCCESS = 'ADD_TEAM_DATA_SUCCESS';
export const UPDATE_TEAM_DATA_REQUEST = 'UPDATE_TEAM_DATA_REQUEST';
export const UPDATE_TEAM_DATA_SUCCESS = 'UPDATE_TEAM_DATA_SUCCESS';
export const DELETE_TEAM_DATA_REQUEST = 'DELETE_TEAM_DATA_REQUEST';
export const DELETE_TEAM_DATA_SUCCESS = 'DELETE_TEAM_DATA_SUCCESS';
export const TOGGLE_ACTIVE_REQUEST = 'TOGGLE_ACTIVE_REQUEST';
export const TOGGLE_ACTIVE_SUCCESS = 'TOGGLE_ACTIVE_SUCCESS';
export const ADD_TEAM_DATA_FAILURE = 'ADD_TEAM_DATA_FAILURE';
export const UPDATE_TEAM_DATA_FAILURE = 'UPDATE_TEAM_DATA_FAILURE';
export const DELETE_TEAM_DATA_FAILURE = 'DELETE_TEAM_DATA_FAILURE';
export const TOGGLE_ACTIVE_FAILURE = 'TOGGLE_ACTIVE_FAILURE';